import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {SmallPopover} from 'icsoc-antd-ex';
import {Popconfirm, message} from 'antd';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import tCallingNumberActions from 'Actions/systemSetting/callingNumber';
import sort from 'Utils/sort';
import IconFont from 'Components/common/iconFont';

const columns = (pageStatus, handleAction) => [
  {
    title: '序号',
    key: 'key',
    dataIndex: 'key',
    width: 60,
    fixed: 'left',
    render: (text, record, index) => {
      const {pageNum, pageSize} = pageStatus;

      return sort({pageNum, pageSize, index});
    },
  },
  {
    title: '主叫号码',
    dataIndex: 'phoneNum',
    key: 'phoneNum',
    width: 250,
    render: text => text || '--',
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    key: 'deptName',
    width: 250,
    render: text => text || '--',
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 120,
    render: text => text || '--',
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: 80,
    fixed: 'right',
    render: (text, record) => (
      <div className="operate">
        <SmallPopover type="white" content="编辑" className="tooltip">
          <IconFont
            type="icon-robotedit"
            onClick={() => handleAction('editNumbers', record)}
          />
        </SmallPopover>
        <SmallPopover type="white" content="删除" className="tooltip">
          <Popconfirm
            placement="leftBottom"
            title="确认删除该号码吗？"
            onConfirm={() => {
              handleAction('confirmDelete', record.id);
            }}>
            <IconFont type="icon-robottrash" />
          </Popconfirm>
        </SmallPopover>
      </div>
    ),
  },
];

class TableList extends UnionTableList {
  handleAction = (type, data) => {
    this[type](data);
  };

  // 编辑主叫号码
  editNumbers = record => {
    const {setEditModalVisible, actions} = this.props;

    setEditModalVisible();
    actions.setEditModalData(record);
  };

  // 删除主叫号码
  confirmDelete = (id = '') => {
    const {
      actions,
      setTableListLoading,
      getTableList,
      pageStatus: {pageNum, pageSize},
      tableListData: {total = 0} = {},
    } = this.props;
    const params = {
      id: String(id),
    };

    setTableListLoading();
    actions
      .deleteCallingNumber(params)
      .then(res => {
        const {payload: {code} = {}} = res || {};

        if (parseInt(code, 10) === 200) {
          message.success('删除成功！');
          this.setState({
            selectedRowKeys: [],
          });
          const {id} = params;
          const newPageNum = Math.ceil((total - id.length) / pageSize);
          const turnPageNum = pageNum < newPageNum ? pageNum : newPageNum || 1;

          this.setPageStatus({
            pageNum: turnPageNum,
          });
          getTableList({
            pageNum: turnPageNum,
            pageSize,
          });
        }
      })
      .finally(() => {
        setTableListLoading();
      });
  };

  render() {
    const {
      tableListData: {data = [], total = 0},
      loading,
      pageStatus,
      administrator,
    } = this.props;
    return (
      <CommonTable
        style={{marginTop: 20}}
        columns={
          administrator === 1
            ? columns(pageStatus, this.handleAction)
            : columns(pageStatus, this.handleAction).slice(0, -1)
        }
        dataSource={[...data]}
        rowKey="id"
        loading={loading}
        extraHeight={20}
        scroll={{x: 1280}}
        onChange={this.handleTableChange}
        pagination={{
          current: pageStatus.pageNum,
          total: total && parseInt(total, 10),
          pageSize: pageStatus.pageSize,
          showTotal: () => `共 ${total} 条`,
        }}
      />
    );
  }
}

const mapStateToProps = ({systemSettingCallingNumber,login}) => ({
  tableListData: systemSettingCallingNumber.tableListData,
  pageStatus: systemSettingCallingNumber.pageStatus,
  administrator: systemSettingCallingNumber.administrator,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tCallingNumberActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
